import Spinner from "react-bootstrap/Spinner";
import info from "../info";

function Loading() {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spinner animation="border" variant="warning" />
    </div>
  );
}

export default Loading;
